import { useEffect } from 'react';
import OneSignal from 'react-onesignal';

const OneSignalSetup = ({ customerId, email, name }) => {
  useEffect(() => {
    const initOneSignal = async () => {
      try {
        // Inizializza OneSignal
        await OneSignal.init({
          appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
          allowLocalhostAsSecureOrigin: process.env.NODE_ENV === 'development',
        });

        console.log('OneSignal inizializzato');

        // Se abbiamo un customerId, associa l'utente
        if (customerId) {
          await OneSignal.login(customerId);
          console.log('Utente OneSignal associato:', customerId);

          // Aggiungi email se disponibile
          if (email) {
            await OneSignal.User.addEmail(email);
          }

          // Aggiungi tag con informazioni utente
          if (name) {
            await OneSignal.User.addTag('user_name', name);
          }
        }

        // Controlla stato sottoscrizione
        const isSubscribed = await OneSignal.User.pushSubscription.getIsSubscribed();
        console.log('Stato sottoscrizione:', isSubscribed);

      } catch (error) {
        console.error('Errore inizializzazione OneSignal:', error);
      }
    };

    initOneSignal();
  }, [customerId, email, name]);

  return null; // Questo componente non renderizza nulla
};

export default OneSignalSetup;
